import { render, staticRenderFns } from "./report_view.vue?vue&type=template&id=b21bc908&"
import script from "./report_view.vue?vue&type=script&lang=js&"
export * from "./report_view.vue?vue&type=script&lang=js&"
import style0 from "./report_view.vue?vue&type=style&index=0&id=b21bc908&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports